import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Lock, ArrowLeft, Code, Heart } from 'lucide-react';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-vault">
      <header className="glass-header sticky top-0 z-50">
        <div className="max-w-3xl mx-auto px-4">
          <div className="flex items-center justify-between h-14">
            <div className="flex items-center gap-2">
              <div className="h-8 w-8 rounded-md bg-[#9333EA] flex items-center justify-center">
                <Lock className="h-4 w-4 text-white" />
              </div>
              <span className="font-heading text-lg font-bold text-white tracking-tight">FutureVault</span>
            </div>
            <Link to="/">
              <Button variant="ghost" size="sm" className="text-[#A19DB0] hover:text-white hover:bg-white/5">
                <ArrowLeft className="h-4 w-4 mr-2" /> Back
              </Button>
            </Link>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <div className="h-20 w-20 rounded-2xl bg-[#9333EA] flex items-center justify-center mx-auto mb-6">
            <Lock className="h-10 w-10 text-white" />
          </div>
          <h1 className="font-heading text-4xl font-black text-white tracking-tight mb-3">
            FutureVault
          </h1>
          <p className="text-[#A19DB0] text-lg">
            The app that stops you from spending your money.
          </p>
        </div>

        <div className="space-y-8">
          <div className="p-6 bg-[#0A0A0F] rounded-xl border border-white/10">
            <h2 className="font-heading text-xl font-bold text-white mb-3">What is FutureVault?</h2>
            <p className="text-[#A19DB0] leading-relaxed">
              FutureVault is a savings app that locks your money until a date you choose. 
              No early withdrawals, no temptation, no excuses. You deposit money, pick a date, 
              and it's locked away until that day comes. When it unlocks, the money goes right 
              back to your bank. Simple.
            </p>
          </div>

          <div className="p-6 bg-[#0A0A0F] rounded-xl border border-white/10">
            <h2 className="font-heading text-xl font-bold text-white mb-3">Why I Built This</h2>
            <p className="text-[#A19DB0] leading-relaxed">
              Saving money shouldn't be hard — but for most people, it is. Not because they 
              don't want to save, but because the money is always right there, easy to spend. 
              FutureVault takes that choice away. Lock it in, forget about it, and let your 
              future self thank you later.
            </p>
          </div>

          <div className="p-8 bg-gradient-to-br from-[#9333EA]/10 to-transparent rounded-xl border border-[#9333EA]/20 text-center">
            <div className="flex items-center justify-center gap-2 mb-3">
              <Code className="h-5 w-5 text-[#9333EA]" />
              <h2 className="font-heading text-xl font-bold text-white">Built by</h2>
            </div>
            <p className="text-2xl font-heading font-black text-white mb-2" data-testid="developer-name">
              Arynn Littlejohn
            </p>
            <p className="text-[#A19DB0] text-sm">Developer & Creator of FutureVault</p>
            <div className="flex items-center justify-center gap-1 mt-4 text-[#A19DB0] text-sm">
              <span>Made with</span>
              <Heart className="h-4 w-4 text-[#9333EA] fill-[#9333EA]" />
              <span>for people who want to save</span>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
